import { render, staticRenderFns } from "./PricingBotRating.vue?vue&type=template&id=49da50fa&"
import script from "./PricingBotRating.vue?vue&type=script&lang=js&"
export * from "./PricingBotRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports